import React, {
  useState,
  useCallback,
  useContext,
  useEffect,
  useRef,
} from "react";
import { ConfigContext } from "../ConfigContextProvider";
import { LocaleContext } from "../LocaleContextProvider";
import { FormattedMessage, injectIntl } from "react-intl";
import { useForm } from "react-hook-form";
import Modal from "react-modal";
import { GoogleReCaptcha } from "react-google-recaptcha-v3";

const FormConfigurator = (props) => {
  const { closeModal, appId, eleId, redirectUri } = props;
  const { REGISTER_URL, COUNTRY_URL, SECTOR_URL, ROLE_URL, PROFESSION_URL, CONFIGURATOR_URL } =
    useContext(ConfigContext);

  const [errorMessage, setErrorMessage] = useState();
  const [successMessage, setSuccessMessage] = useState();
  const { locale } = useContext(LocaleContext);

  //register
  const [mode, setMode] = useState("LOGIN");

  const [countries, setCountries] = useState();
  const [roles, setRoles] = useState();
  const [sectors, setSectors] = useState();
  const [userOptionsData, setUserOptionsData] = useState({}); // Nuovo stato per i dati userOptions

  const [status, setStatus] = useState();
  const [token, setToken] = useState("");
    const [isLoading, setIsLoading] = useState(false); // Nuovo stato per il loading
  const [statusChangePwd, setStatusChangePwd] = useState();
   const [professions, setProfessions] = useState();

  const translateText = function (tstr) {
    return props.intl.formatMessage({
      id: tstr,
    });
  };

  const verifyRecaptchaCallback = React.useCallback((token) => {
    setToken(token);
  }, []);

  const genericError = props.intl.formatMessage({
    id: "generic.form.error",
  });

  const { register, handleSubmit, watch, errors, setValue } = useForm({
    mode: "all",
    reValidateMode: "all",
    defaultValues: {},
    resolver: undefined,
    context: undefined,
    criteriaMode: "firstError",
    shouldFocusError: true,
    shouldUnregister: true,
  });

  const passwordWatch = useRef({});
  passwordWatch.current = watch("pwd", "");

  // Funzione userOption adattata per React
  const fetchUserOptions = async (customParams = {eleid:eleId, lang:locale}) => {
    const baseUrl = "https://www.flou.it/bedconfigurator/model/useroptions.php";

    // Prendi i parametri esistenti dalla URL
    const urlParams = new URLSearchParams(window.location.search);

    // Aggiungi i parametri custom
    Object.keys(customParams).forEach((key) => {
      if (customParams[key] !== null && customParams[key] !== undefined) {
        urlParams.set(key, customParams[key]);
      }
    });

    // Costruisci l'URL finale
    const url = urlParams.toString()
      ? `${baseUrl}?${urlParams.toString()}`
      : baseUrl;

    let data = {};

    try {
      const response = await fetch(url);
      if (response.ok) {
        data = await response.json();
      }
    } catch (error) {
      console.error("Errore fetchUserOptions:", error);
    }

    return data;
  };

  const convertToEntities = function (tstr) {
    var bstr = "";
    for (let i = 0; i < tstr.length; i++) {
      if (tstr.charCodeAt(i) > 127) {
        bstr += "&#" + tstr.charCodeAt(i) + ";";
      } else {
        bstr += tstr.charAt(i);
      }
    }
    return bstr;
  };

  const onSignIn = useCallback(
    (data) => {
      setIsLoading(true);
      setStatus();
      setSuccessMessage();

      

      // Prepara i dati per la nuova API PHP
      const allData = {
        appId: appId,
        eleId: eleId,
        ...data,
        ...userOptionsData.settings,
        action: "submit", // Specifica l'azione per la nuova API
        locale: locale, // Aggiungi locale se disponibile
        redirect_uri: redirectUri || window.location.href, // Usa redirect_uri dalle props o fallback all'URL corrente
      };

      // Converti in URLSearchParams invece di FormData per compatibilità
      const formData = new URLSearchParams();

      for (var i in allData) {
        if (i === "usr") {
          formData.append(i, convertToEntities(allData[i]));
        } else {
          formData.append(i, allData[i]);
        }
      }

      // Chiama la nuova API PHP
      fetch(CONFIGURATOR_URL, {
        // Cambia REGISTER_URL con la nuova URL
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData,
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((responseJson) => {
          // Gestisci la nuova struttura della response
          if (!responseJson.success) {
            throw new Error(responseJson.error || "Errore sconosciuto");
          }
          // La response della nuova API ha una struttura diversa, adatta in base ai dati effettivi
          const settings = extractSettingsFromResponse(responseJson);

          if (settings.ssid) {
            localStorage.setItem("ssid", settings.ssid);
          }
          if (responseJson.success && responseJson.data.result.redirect_url) {
            console.log(responseJson);
            console.log(responseJson.data.result.redirect_url, "---> redirect_url");
            window.location.href = responseJson.data.result.redirect_url;
        }

          if (settings.login === "1") {
            // Prepara i dati per GTM
            setStatus("SUCCESS");
          } else {
            setErrorMessage(
              translateText(settings.loginmsg || "Errore di login")
            );
          }
        })
        .catch((error) => {
          console.error("Errore onSignIn:", error);
          setErrorMessage(genericError);
        }).finally(() => {
          setIsLoading(false); // Disattiva il loading sia in caso di successo che errore
        });
    },
    [userOptionsData, locale, appId, translateText, genericError, redirectUri]
  );

  // Funzione helper per estrarre i settings dalla nuova response
  function extractSettingsFromResponse(responseJson) {
    // Adatta questa funzione in base alla struttura effettiva della response della tua API

    if (responseJson.data && responseJson.data.result) {
      // Se i settings sono in data.result
      return responseJson.data.result;
    }

    if (responseJson.data && responseJson.data.userOption) {
      // Se i settings sono in data.userOption
      return responseJson.data.userOption;
    }

    // Se i settings sono direttamente in data
    if (responseJson.data) {
      return responseJson.data;
    }

    // Fallback: restituisci un oggetto vuoto con valori di default
    return {
      login: "0",
      ssid: null,
      uidr: null,
      loginmsg: "Errore nella risposta del server",
    };
  }

  useEffect(() => {
    // Carica countries, roles, sectors come prima
    fetch(COUNTRY_URL)
      .then((res) => res.json())
      .then(
        (result) => {
          setCountries(result.countries);
        },
        (error) => {}
      );

    /*fetch(ROLE_URL + "_" + locale + ".json")
      .then((res) => res.json())
      .then(
        (result) => {
          setRoles(result.ruoli);
        },
        (error) => {}
      );

    fetch(SECTOR_URL + "_" + locale + ".json")
      .then((res) => res.json())
      .then(
        (result) => {
          setSectors(result.settori);
        },
        (error) => {}
      );*/

      fetch(PROFESSION_URL + "_" + locale + ".json")
      .then((res) => res.json())
      .then(
        (result) => {
          setProfessions(result.professioni);
        },
        (error) => {}
      );

    // Carica userOptions e imposta i valori del form
    fetchUserOptions().then((data) => {
      if (Object.keys(data).length > 0) {
        setUserOptionsData(data);

        // Imposta i valori nel form per i campi esistenti
        /*Object.entries(data).forEach(([key, value]) => {
          // Solo per campi che esistono nel form
          if (['name', 'surname', 'email', 'phone', 'country', 'city', 'company', 'lang', 'appId'].includes(key)) {
            setValue(key, value);
          }
        });*/
      }
    });
  }, [setValue]);

  const appIdLabel = (appId && appId.length) > 0 ? appId + "." : "";

  return (
    <>
    {/* Loading Overlay */}
      {isLoading && (
        <div className="loading-overlay">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p className="loading-text">
              <FormattedMessage id="form.loading.message" defaultMessage="Invio in corso..." />
            </p>
          </div>
        </div>
      )}
      {status === "SUCCESS" ? (
        <>
          <div className="AuthenticationModal__title">
            <div className="AuthenticationModal__title">
              <h1>
                <FormattedMessage id={"register.form.title.success"} />
              </h1>
            </div>
          </div>
          <div className="AuthenticationModal__message">
            <p
              dangerouslySetInnerHTML={{
                __html: props.intl.formatMessage({
                  id: "register.form.success",
                }),
              }}
            />
          </div>
        </>
      ) : (
        <>
          <div className="AuthenticationModal__title">
            <div className="AuthenticationModal__title">
              <h1>
                <FormattedMessage id={appIdLabel + "register.form.title"} />
              </h1>
              <p
                dangerouslySetInnerHTML={{
                  __html: props.intl.formatMessage({
                    id: appIdLabel + "register.form.description",
                  }),
                }}
              />
            </div>
          </div>
          {errorMessage && <p className="textInput__error">{errorMessage}</p>}
          <form onSubmit={handleSubmit(onSignIn)}>
            <input
              type="hidden"
              name="g-recaptcha-response"
              value={token}
              ref={register({ required: true })}
            />
            <input
              type="hidden"
              name="lang"
              defaultValue={locale}
              ref={register({ required: true })}
            />
            <input
              type="hidden"
              name="appId"
              defaultValue={appId}
              ref={register()}
            />


            <div className="AuthenticationModal__rowForm">
              {/* nome */}
              <div className="textInput__wrapper">
                <input
                  className="textInput__input"
                  name="frm_nome"
                  placeholder={`${props.intl.formatMessage({
                    id: "placeholder.name",
                  })}*`}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                  })}
                />
                {errors.name && errors.name.message && (
                  <p className="textInput__error">{errors.name.message}</p>
                )}
              </div>

              {/* cognome */}
              <div className="textInput__wrapper">
                <input
                  className="textInput__input"
                  name="frm_cognome"
                  placeholder={`${props.intl.formatMessage({
                    id: "placeholder.surname",
                  })}*`}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                  })}
                />
                {errors.surname && errors.surname.message && (
                  <p className="textInput__error">{errors.surname.message}</p>
                )}
              </div>
            </div>
            <div className="AuthenticationModal__rowForm">
              {/* email */}
              <div className="textInput__wrapper">
                <input
                  className="textInput__input"
                  name="frm_email"
                  placeholder={`${props.intl.formatMessage({
                    id: "placeholder.email",
                  })}*`}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                      message: props.intl.formatMessage({
                        id: "validation.email",
                      }),
                    },
                  })}
                />
                {errors.email && errors.email.message && (
                  <p className="textInput__error">{errors.email.message}</p>
                )}
              </div>

              {/* phone */}
              <div className="textInput__wrapper">
                <input
                  className="textInput__input"
                  name="frm_telefono"
                  placeholder={`${props.intl.formatMessage({
                    id: "placeholder.phone",
                  })}*`}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                  })}
                />
                {errors.phone && errors.phone.message && (
                  <p className="textInput__error">{errors.phone.message}</p>
                )}
              </div>
            </div>
            <div className="AuthenticationModal__rowForm">
              {/* country */}
              <div className="textInput__wrapper">
                <select
                  name="frm_nazione"
                  defaultValue=""
                  className="textInput__input"
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                    pattern: {
                      value: /^[a-zA-Z]{2,}$/,
                      message: props.intl.formatMessage({
                        id: "validation.required",
                      }),
                    },
                  })}
                >
                  <option key={"option"} value={""} disabled>
                    {`${props.intl.formatMessage({
                      id: "placeholder.select.country",
                    })}*`}
                  </option>
                  {countries &&
                    countries.map((item, i) => {
                      return (
                        <option key={"option" + i} value={item.id}>
                          {item.label}
                        </option>
                      );
                    })}
                </select>
                {errors.country && errors.country.message && (
                  <p className="textInput__error">{errors.country.message}</p>
                )}
              </div>

              {/* city */}
              <div className="textInput__wrapper">
                <input
                  className="textInput__input"
                  name="frm_citta"
                  placeholder={`${props.intl.formatMessage({
                    id: "placeholder.city",
                  })}*`}
                  ref={register({
                    required: props.intl.formatMessage({
                      id: "validation.required",
                    }),
                  })}
                />
                {errors.city && errors.city.message && (
                  <p className="textInput__error">{errors.city.message}</p>
                )}
              </div>
            </div>

            <div className="AuthenticationModal__rowForm">

                {/* nome */}
                <div className="textInput__wrapper">
                  <input
                    className="textInput__input"
                    name="frm_indirizzo"
                    placeholder={`${props.intl.formatMessage({
                      id: "placeholder.address",
                    })}*`}
                    ref={register({
                      required: props.intl.formatMessage({
                        id: "validation.required",
                      }),
                    })}
                  />
                  {errors.name && errors.name.message && (
                    <p className="textInput__error">{errors.address.message}</p>
                  )}
                </div>


                {/* prfessini */}
                <div className="textInput__wrapper">
                  <select
                    name="frm_professione"
                    defaultValue=""
                    className="textInput__input"
                    ref={register({
                      required: props.intl.formatMessage({
                        id: "validation.required",
                      }),
                      pattern: {
                        value: /.+/,
                        message: props.intl.formatMessage({
                          id: "validation.required",
                        }),
                      },
                    })}
                  >
                    <option key={"option"} value={""} disabled>
                    {`${props.intl.formatMessage({
                      id: "placeholder.select.professions",
                    })}*`}
                    </option>
                    {professions &&
                      professions.map((item, i) => {
                        return (
                          <option key={"option" + i} value={item.id}>
                            {item.label}
                          </option>
                        );
                      })}
                  </select>
                  {errors.profession && errors.profession.message && (
                    <p className="textInput__error">
                      {errors.profession.message}
                    </p>
                  )}
                </div>
              </div>

           

            <p className="AuthenticationModal__policy">
              <span
                dangerouslySetInnerHTML={{
                  __html: props.intl.formatMessage({
                    id: "bedconfigurator.register.policy.description",
                  }),
                }}
              />
            </p>
            
            <p></p>

            <div className="textInput__wrapper textInput__wrapper--policy">
                <div className="textInput__policyBlock">
                  <input
                    type="checkbox"
                    className="textInput__checkboxPolicy"
                    name="policy_b"
                    id="policy_b"
                    ref={register({
                      
                    })}
                  />
                  <div>
                    <label
                      htmlFor="policy_b"
                      className="textInput__policy"
                      dangerouslySetInnerHTML={{
                        __html: props.intl.formatMessage({
                          id: "bedconfigurator.form.policy_b",
                        }),
                      }}
                    ></label>
                  </div>
                </div>
              </div>

              <div className="textInput__wrapper textInput__wrapper--policy">
                <div className="textInput__policyBlock">
                  <input
                    type="checkbox"
                    className="textInput__checkboxPolicy"
                    name="policy_c"
                    id="policy_c"
                    ref={register({
                      
                    })}
                  />
                  <div>
                    <label
                      htmlFor="policy_c"
                      className="textInput__policy"
                      dangerouslySetInnerHTML={{
                        __html: props.intl.formatMessage({
                          id: "bedconfigurator.form.policy_c",
                        }),
                      }}
                    ></label>
                  </div>
                </div>
              </div>

            <GoogleReCaptcha onVerify={verifyRecaptchaCallback} />

            <button type="submit" className="AuthenticationModal__button">
              <FormattedMessage id={"register.form.button"} />
            </button>
          </form>

          <p className="AuthenticationModal__note">
            <FormattedMessage id={"register.form.login.description"} />{" "}
            <a
              className="AuthenticationModal__link"
              onClick={() => props.onSwitchMode("LOGIN")}
            >
              <FormattedMessage id={"register.form.login.link"} />
            </a>
          </p>
        </>
      )}
    </>
  );
};

export default injectIntl(FormConfigurator);
